export function roundTo2Dp(x: number) {
    return Math.round(x * 100) / 100;
}

export const formatNumberToKNotation = (n: number): string => {
    const exponent = Math.floor(Math.log10(Math.abs(n)));
    const sliceRules = [
        { threshold: 3, exponentSign: '', format: (n: number) => n },
        {
            threshold: 4,
            exponentSign: 'K',
            format: (n: number) => {
                const formatted = (Math.floor((n / Math.pow(10, exponent)) * 10) / 10).toFixed(1);
                if (Number(formatted) - Math.floor(Number(formatted)) === 0) {
                    return parseInt(String(formatted));
                }

                return formatted;
            },
        },
        {
            threshold: 6,
            exponentSign: 'K',
            format: (n: number) => Math.round(n).toString(10).slice(0, -3),
        },
        {
            threshold: 7,
            exponentSign: 'M',
            format: (n: number) => {
                const formatted = (Math.floor((n / Math.pow(10, exponent)) * 10) / 10).toFixed(1);
                if (Number(formatted) - Math.floor(Number(formatted)) === 0) {
                    return parseInt(String(formatted));
                }

                return formatted;
            },
        },
        {
            threshold: 8,
            exponentSign: 'M',
            format: (n: number) => {
                const formatted = (Math.floor((n / Math.pow(10, exponent)) * 100) / 10).toFixed(1);
                if (Number(formatted) - Math.floor(Number(formatted)) === 0) {
                    return parseInt(String(formatted));
                }

                return formatted;
            },
        },
        {
            threshold: Infinity,
            exponentSign: 'M',
            format: (n: number) => Math.round(n).toString(10).slice(0, -6),
        },
    ];

    const rule = sliceRules.find((r) => r.threshold > exponent);
    if (!rule) {
        return n.toString();
    }

    return `${rule.format(n)}${rule.exponentSign}`;
};

export function numberWithCommas(n: number | string) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const displayOptionalNumericTableValue = (
    value: string | number | undefined | null,
    emptyValueRepresentation = '-'
) => {
    return !isNaN(Number(value)) && value !== undefined && value !== null
        ? numberWithCommas(value)
        : emptyValueRepresentation;
};
